import { apiService } from './apiService';

export const expenseService = {
  // Get all expenses
  async getExpenses(params?: { 
    status?: string; 
    driverId?: string; 
    submittedBy?: string;
    startDate?: string; 
    endDate?: string;
  }) {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.driverId) queryParams.append('submittedBy', params.driverId);
    if (params?.submittedBy) queryParams.append('submittedBy', params.submittedBy);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    
    const query = queryParams.toString();
    return await apiService.get(`/expenses${query ? `?${query}` : ''}`);
  },

  // Get expense by ID
  async getExpense(id: string | number) {
    return await apiService.get(`/expenses/${id}`);
  },

  // Create expense
  async createExpense(data: any) {
    return await apiService.post('/expenses', data);
  },

  // Update expense
  async updateExpense(id: string | number, data: any) {
    return await apiService.put(`/expenses/${id}`, data);
  },

  // Delete expense
  async deleteExpense(id: string | number) {
    return await apiService.delete(`/expenses/${id}`);
  },

  // Update expense status
  async updateExpenseStatus(id: string | number, status: string, notes?: string) {
    if (status === 'approved') {
      return await apiService.put(`/expenses/${id}/approve`, { notes });
    }
    if (status === 'rejected') {
      return await apiService.put(`/expenses/${id}/reject`, { notes });
    }
    if (status === 'paid') {
      return await apiService.put(`/expenses/${id}/mark-paid`, {});
    }
    return await apiService.put(`/expenses/${id}`, { status, notes });
  },

  // Get payment orders
  async getPaymentOrders(params?: { status?: string; startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    
    const query = queryParams.toString();
    return await apiService.get(`/payment-orders${query ? `?${query}` : ''}`);
  },

  // Create payment order
  async createPaymentOrder(data: any) {
    return await apiService.post('/payment-orders', data);
  },

  // Update payment order
  async updatePaymentOrder(id: string | number, data: any) {
    return await apiService.put(`/payment-orders/${id}`, data);
  },

  async markPaymentOrderPaid(id: string | number, paidBy?: string | number) {
    return await apiService.put(`/payment-orders/${id}/mark-paid`, { paidBy });
  },
};
